import { getDomain, parseQuery } from '@libs/utils';

import { statsigFeatureMap } from '../statsig/statsigFeatureToggles';

import type { FeatureToggleName } from './customFeatureTogglesTypes';

export const enum FeaturePrefix {
  TripPlanner = 'btf-tp',
  SmartSearch = 'btf-ss',
}

export function isFeatureToggleActive(featureName: FeatureToggleName): boolean {
  const shouldApplyStatsigExperiment =
    (getDomain.isProduction || getDomain.isStaging) &&
    featureName in statsigFeatureMap;

  if (shouldApplyStatsigExperiment) {
    return !!statsigFeatureMap[featureName]?.value;
  }

  const features = getActiveFeatureToggles(FeaturePrefix.TripPlanner);

  return features.has(featureName);
}

export function getActiveFeatureToggles(
  featurePrefix: FeaturePrefix
): Set<string> {
  const query = parseQuery(window.location.search);

  const features = query[featurePrefix] ?? [];

  return new Set(features);
}

export function getMultiExperimentOverrides(
  featurePrefix: FeaturePrefix
): Map<string, string> {
  const query = parseQuery(window.location.search);

  const features = query[featurePrefix] ?? [];

  const overrides = new Map<string, string>();

  for (const feature of features) {
    if (feature.includes(';')) {
      const [experimentName, value] = feature.split(';', 2);
      if (experimentName && value) {
        overrides.set(experimentName, value);
      }
    }
  }

  return overrides;
}

export function getSmartSearchSerializedFeatureToggles(): string[] {
  const smartSearchFeatureToggles = getActiveFeatureToggles(
    FeaturePrefix.SmartSearch
  );

  return Array.from(smartSearchFeatureToggles);
}
